import angular from 'angular';

import EntityCategoriesMobilePreviewComponent from './entity-categories-mobile-preview.component';

const EntityCategoriesMobilePreviewModule = angular
    .module('control-room.commons.content.entity-categories.entity-categories-mobile-preview', [])
    .component('crEntityCategoriesMobilePreview', EntityCategoriesMobilePreviewComponent);

export default EntityCategoriesMobilePreviewModule;
